import AccessDenied from "./AccessDenied";
import DecryptData from "./Decrypt";

export function GetAccess(accessText){
    if(GetRole()){
        return true
    }else{
        const userAccess = localStorage.getItem("sSeCcArEsUeDaRt")?DecryptData("sSeCcArEsUeDaRt"):[]        
        const access = userAccess?userAccess.some((permission)=>permission.permissionName == accessText ):false;
            console.log("access",userAccess);
            console.log(accessText,"accessText");
            

        return access;
    }
}


export function GetMultipleAccess(accessTextArr = []) {
    const userAccess = localStorage.getItem("sSeCcArEsUeDaRt")?DecryptData("sSeCcArEsUeDaRt"):[];
    if(GetRole()){
        return true
    }else{
    if(accessTextArr.length>0){
    const access = accessTextArr?.some(element => userAccess?.some(userObj => userObj?.permissionName === element));
    return access;

    }
    else{
    return false;

    }
   

    }
}




export function GetRole(){
    const userData = localStorage.getItem("sLiAtEdReSuEdArT")?DecryptData("sLiAtEdReSuEdArT"):[];
    const role = userData?.role;
    if(role ==="super admin"||role==="admin"){
        return true
    }else{
        return false
    }
}

export function GetDashboardRole(giveRole="") {
    // const encryptedUserData = localStorage.getItem("sLiAtEdReSuEdArT");
    const userData = localStorage.getItem("sLiAtEdReSuEdArT")?DecryptData("sLiAtEdReSuEdArT"):[];
    const role = userData?.role;
    if(role ==="super admin"||role==="admin"){
        return true
    }else if(role === giveRole){
        return true
    }else{
        return false
    }

}

export function GetDashboardMultiRole(giveRole=[]) {
    // const encryptedUserData = localStorage.getItem("sLiAtEdReSuEdArT");
    const userData = localStorage.getItem("sLiAtEdReSuEdArT")?DecryptData("sLiAtEdReSuEdArT"):[];
    const role = userData?.role;
    if(role ==="super admin"||role==="admin"){
        return true
    }else if( giveRole.some(r=>r===role)){
        return true
    }else{
        return false
    }

}


export function GetNotUseRole(giveRole="") {
    // const encryptedUserData = localStorage.getItem("sLiAtEdReSuEdArT");
    const userData = localStorage.getItem("sLiAtEdReSuEdArT")?DecryptData("sLiAtEdReSuEdArT"):[];
    const role = userData?.role;
    if(role ==="super admin"||role==="admin"){
        return true
    }else if(role === giveRole){

        return false
    }else{
        return true
    }

}


export function GetUseRole(giveRole="") {
    // const encryptedUserData = localStorage.getItem("sLiAtEdReSuEdArT");
    const userData = localStorage.getItem("sLiAtEdReSuEdArT")?DecryptData("sLiAtEdReSuEdArT"):[];
    const role = userData?.role;
    
    
    if(role === giveRole){
        return true
    }else{
        return false
    }

}



export function RendorPage(accessKey,Component){
if( (GetRole()||GetAccess(accessKey)) == true){
    return <Component/>
}else{
    return <AccessDenied/>
}
}


export function Wrapper({accessKey,Component}){
    return RendorPage(accessKey, Component);
  }